import AddIcon from '@mui/icons-material/Add';
import React, { useContext } from 'react';
import { PermissionsContext } from '../../UIContainer/PermissionsWrapper';
import PermissionConstants from '../../../Common/Constants/PermissionConstants';
import { Link } from 'react-router-dom';
import { SqlServerHeaderToolbarProps } from '../Model/SqlServerProps';
import HeaderToolbar from '../../../../Common/Components/HeaderToolbar';
import SearchBar from '../../../../Common/Components/Controls/SearchBar';
import CustomButton from '../../../../Common/Components/Controls/InputControls';

const SqlServerHeaderToolbar = ({
  onFilterRequest,
}: SqlServerHeaderToolbarProps) => {
  const permissions = useContext(PermissionsContext);
  const hasSqlServerWritePermission =
    permissions[PermissionConstants.SqlServerWriter];

  return (
    <HeaderToolbar
      leftContent={<SearchBar onChange={onFilterRequest} width="35%" />}
      rightContent={
        hasSqlServerWritePermission && (
          <CustomButton
            startIcon={<AddIcon />}
            component={Link}
            to="/sqlserver/create"
            label="Add"
          />
        )
      }
    />
  );
};

export default SqlServerHeaderToolbar;
